import { createAsyncReducer } from '@telstra-connect/standard-actions/reducers';
import {
    ILoadRaisedForAction,
    ILoadRaisedForSuccessAction,
    ILoadRaisedForErrorAction
} from '@telstra-connect/tickets/actions/raised-for';
import { ITicketsState } from '@telstra-connect/tickets/state';
import { initialState } from '@telstra-connect/tickets/reducers/initial-state';

export type RaisedForAction
    = ILoadRaisedForAction
    | ILoadRaisedForSuccessAction
    | ILoadRaisedForErrorAction;

const init = (state: ITicketsState, action: RaisedForAction) => ({
    ...state,
    raisedForRequest: {
        ...initialState.raisedForRequest,
        status: action.status,
    }
});

const success = (state: ITicketsState, action: RaisedForAction) => ({
    ...state,
    raisedForRequest: {
        ...initialState.raisedForRequest,
        status: action.status,
        data: (action as ILoadRaisedForSuccessAction).data
    }
});

const failure = (state: ITicketsState, action: RaisedForAction) => ({
    ...state,
    raisedForRequest: {
        ...initialState.raisedForRequest,
        status: action.status,
        error: (action as ILoadRaisedForErrorAction).error
    }
});

export const raisedForReducer = createAsyncReducer(initialState, init, success, failure);
